
import { Vue } from 'vue-property-decorator';
import { Mixins, Component } from 'vue-mixin-decorator';
import Bookmark from '@/mixins/common/bookmark';
import { namespace } from 'vuex-class';
import { VuexAction } from '@/types/functions';

const advertsStore = namespace('adverts');

@Component
export default class AdvertActionBookmark extends Mixins<Bookmark>(Bookmark) {
  @advertsStore.Action addToBookmarks!: VuexAction;
  @advertsStore.Action removeFromBookmarks!: VuexAction;
}
